module.exports = __webpack_public_path__ + "img/rent-3.c715d97f.png";